module.exports = __webpack_public_path__ + "img/72.6.CODm.ad2aa170.png";